import { css, styled } from 'css-literal-loader/styled';
import { Link } from 'gatsby';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '@4c/layout';

import paths from '../paths';
import withReservation from '../utils/Reservation';

const styles = require('./BreadCrumbs-styles.module.scss');

const BreadCrumb = styled('div', null, "BreadCrumb", require("./BreadCrumbs-BreadCrumb.module.scss"), "bread-crumb", "breadCrumb");

const crumbs = {
  bundle: {
    path: paths.bundle,
    message: (
      <FormattedMessage id="breadcrumbs.bundle" defaultMessage="Bundle" />
    ),
  },
  configure: {
    path: paths.configure,
    message: (
      <FormattedMessage
        id="breadcrumbs.configure"
        defaultMessage="Configure"
      />
    ),
  },
  checkout: {
    path: paths.checkout,
    message: (
      <FormattedMessage id="breadcrumbs.checkout" defaultMessage="Checkout" />
    ),
  },
};
const routeNames = Object.keys(crumbs);

const propTypes = {};

function BreadCrumbs({ active, title, cart }) {
  const activeIndex = routeNames.indexOf(active);
  const allowBackLinks = !cart.remote.isDeviceOnly;
  return (
    <div className={styles.breadCrumbs}>
      <Link to="/" className={styles.logo}>
        <img alt="Home" />
      </Link>
      <Layout grow align="flex-start" justify="center" className={styles.nav}>
        {Object.values(crumbs).map(({ path, message }, idx) => {
          const isActive = activeIndex === idx;
          const msg = isActive && title ? title : message;
          return (
            <BreadCrumb key={path} active={isActive}>
              {allowBackLinks && activeIndex > idx ? (
                <Link to={path}>{msg}</Link>
              ) : (
                msg
              )}
            </BreadCrumb>
          );
        })}
      </Layout>
    </div>
  );
}

BreadCrumbs.propTypes = propTypes;

export default withReservation(BreadCrumbs);
